module.exports = __webpack_public_path__ + "static/media/GeneralInfoBanner.6c8826e0.jpg";